// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3J6pf","errorLogs":"EditorFooter_errorLogs__3pzRp"};